import { Component } from '@angular/core';
import { IRevisione } from "../../../models/interfaces/revisione.interface";
import { IDatiBusiness } from "../../../models/interfaces/dati-business.interface";
import { Revisione53CoreActions } from "../../../store/revisione53.actions";
import { Store } from "@ngrx/store";
import { Revisione53State } from "../../../store/revisione53.reducers";
import { IRevisioneDatiBusiness } from "../../../models/interfaces/revisione-business.interface";
import { revisione53CoreHelpers } from "../revisione53-main-container.helpers";
import { JSON_FILE_PREFIX } from "@shared/constants/shared.constants";
import { IndexedDBService } from "@core/services/indexeddb.service";
import { nanoid } from "nanoid";
import { cloneDeep, set } from 'lodash-es'
import { Revisione53CoreSelectors } from "../../../store/selectors/core.selectors";
import { map, mergeMap, take } from "rxjs/operators";
import { Observable } from "rxjs";
import { CryptoService } from "@core/services/crypto.service";
import { FormControl } from "@angular/forms";

@Component({
    selector: 'app-carica-da-pc',
    templateUrl: './carica-da-pc.component.html',
    styleUrls: ['./carica-da-pc.component.scss'],
})
export class CaricaDaPcComponent {

    backupFileControl: FormControl;

    constructor(
        private store: Store<Revisione53State>,
        private indexedDb: IndexedDBService,
        private cryptoService: CryptoService
    ) {
      this.backupFileControl = new FormControl(null);
    }

    upload(event): void {
        const selectedFile = event.target.files[0];

        const fileReader = new FileReader();
        fileReader.readAsText(selectedFile, "UTF-8");
        fileReader.onload = () => {
            try {
                const decryptPsw = prompt("Inserisci la password con cui è stato salvato il file");

                const fileReaderResult = this.cryptoService.decrypt(fileReader.result as string, decryptPsw)
                const jsonInput: { revisione: IRevisione, datiBusiness: IDatiBusiness } = JSON.parse(fileReaderResult);

                if (!jsonInput.revisione || !jsonInput.datiBusiness) {
                    alert('Il file inserito non è valido')
                    throw new Error('Il json inserito non è valido')
                }

                this.uploadRevisione(jsonInput)

            } catch (err) {
                console.error("parsing file fallito", err);
                alert('Errore nel caricamento del file. Controlla che la password sia corretta.');
            } finally {
              this.backupFileControl.reset();
            }
        }
        fileReader.onerror = (error) => {
            console.error('fileReader.onerror', error);
        }
    }

    private uploadRevisione(uploadedRevisioneDatiBusiness: IRevisioneDatiBusiness): void {
        let positions = revisione53CoreHelpers.getAllegatiPositionAndValue(uploadedRevisioneDatiBusiness.revisione, JSON_FILE_PREFIX);
        let revisione: IRevisione = cloneDeep(uploadedRevisioneDatiBusiness.revisione)

        const filesToAdd = positions.map(p => {

            const file = revisione53CoreHelpers.fromBase64StringToFile(p.value)

            return {
                ...p,
                file,
                id: nanoid()
            }
        })

        // TODO: togli tutti gli allegati della revisione53 attualmente presente


        this.indexedDb.bulkAdd(filesToAdd).pipe(
            mergeMap(() => {
                filesToAdd.forEach(file => {
                    set(revisione, file.position, IndexedDBService.idPrefix + file.id)
                })

                return this.deleteCurrentAllegati()
            })
        ).subscribe(() => {
          this.store.dispatch(Revisione53CoreActions.revisione53hydrated({
            revisione,
            datiBusiness: uploadedRevisioneDatiBusiness.datiBusiness
          }))
        })
    }

    private deleteCurrentAllegati(): Observable<any> {
        return this.store.select(Revisione53CoreSelectors.getRevisione).pipe(
            take(1),
            map(currentRevisione => revisione53CoreHelpers.getAllegatiPositionAndValue(currentRevisione).map(a => a.value)),
            mergeMap(ids => this.indexedDb.bulkDelete(ids))
        )
    }


}
